import { kBiGridGapPx } from '@euler/app/flows/bi-dashboards/functions/biGridLayout';
import { ReactNode } from 'react';
import { View } from 'react-native';
import { biGalleryColumnCount } from '../functions/biGalleryWidth';

/** Items in rows, as many per row as a dashboard puts at this width. */
export function GalleryGrid<T>({
  width,
  items,
  keyOf,
  render,
}: {
  /** The measured width of the preview frame. */
  width: number;
  items: T[];
  keyOf: (item: T) => string;
  render: (item: T, cellWidth: number) => ReactNode;
}) {
  const columns = biGalleryColumnCount(width);
  const cell = Math.floor((width - kBiGridGapPx * (columns - 1)) / columns);
  return (
    <View
      style={{
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        columnGap: kBiGridGapPx,
        rowGap: kBiGridGapPx * 2,
      }}
    >
      {items.map(item => (
        <View key={keyOf(item)}>{render(item, cell)}</View>
      ))}
    </View>
  );
}
